import axios from "axios";
import { MEETINGS_BACK_URL } from "@/config";
import { getUserTimezone } from "@/utils/dates";

const axiosCallCenter = axios.create({
  baseURL: MEETINGS_BACK_URL,
});

axiosCallCenter.interceptors.request.use((config) => {
  config.headers['X-Timezone'] = getUserTimezone();
  return config;
});

export default axiosCallCenter;
